import { format } from "date-fns";

// Wrapper for a field that scrollToField can find, without changing the layout
export const fieldWrapperProps = (name) => ({
  "data-field": name,
  style: { display: "contents" },
});

// Scrolls the field marked with data-field="<name>" into view
export const scrollToField = (name) => {
  requestAnimationFrame(() => {
    const element = document.querySelector(`[data-field="${name}"]`);
    if (!element) return;

    // A display: contents wrapper has no box of its own - scroll to the field inside it
    const target =
      getComputedStyle(element).display === "contents" ? element.firstElementChild : element;
    target?.scrollIntoView({ behavior: "smooth", block: "center" });
  });
};

// Scrolls a message (e.g. a server error shown at the end of a long form) into view
export const scrollIntoViewIfPresent = (element) => {
  element?.scrollIntoView({ behavior: "smooth", block: "center" });
};

// Returns the name of the first invalid field, from [name, errorText] pairs
// that were all validated already (so every error is shown at once)
export const firstInvalidField = (results) => results.find(([, errorText]) => !!errorText)?.[0];

// Formats a date/time value, "-" for empty or invalid values (instead of 01/01/1970 or "now")
export const formatDateSafe = (value, pattern = "dd/MM/yyyy") => {
  if (!value) return "-";

  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime())) return "-";

  return format(date, pattern);
};

// The report description is edited as one text but saved in two fields:
// JOBDESC (first 67 characters) and JOBDESCLONG (the rest), as the desktop form always did
const REPORT_DESCRIPTION_SPLIT_AT = 67;
export const REPORT_DESCRIPTION_MAX_LENGTH = 120;

export const joinReportDescription = (report) =>
  `${report?.JOBDESC ?? ""}${report?.JOBDESCLONG ?? ""}`;

export const splitReportDescription = (text = "") => ({
  JOBDESC: text.substring(0, REPORT_DESCRIPTION_SPLIT_AT),
  JOBDESCLONG: text.substring(REPORT_DESCRIPTION_SPLIT_AT),
});

// Upload limit for attached files (no limit was defined elsewhere in the app)
export const MAX_FILE_SIZE_MB = 10;
